module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-card",
    on: {
      "click": _vm.viewProduct
    }
  }, [_c('div', {
    staticClass: "pic-wrap"
  }, [_c('img', {
    class: _vm.imageClass,
    attrs: {
      "src": _vm.productImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "count-num"
  }, [_vm._v("数量：" + _vm._s(_vm.cardData.productData.soncount || 0))]), _vm._v(" "), _c('div', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.cardData.productData.productName || _vm.unKnowName))]), _vm._v(" "), _c('div', {
    staticClass: "product-batch-name"
  }, [_vm._v(_vm._s(_vm.cardData.productData.ProductBatchCode))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-d8760ae6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-d8760ae6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/pack/product-card.vue
// module id = 1083
// module chunks = 1